import request from '@/utils/request'
let OrderApi = {
  /*卡资源表-列表*/
  cardResourcesSelectList (data, errorback) {
    return request._postBody('/shop/cardApply/cardResources/selectList', data, errorback);
  },

  /*卡资源表-新增*/
  add (data, errorback) {
    return request._postBody('/shop/cardApply/cardResources/addCardResources', data, errorback);
  },

  /*卡资源表-修改*/
  amend (data, errorback) {
    return request._postBody('/shop/cardApply/cardResources/amend', data, errorback);
  },

  /*卡资源表-删除*/
  delete (data, errorback) {
    return request._get('/shop/cardApply/cardResources/delete', data, errorback);
  },

  /*卡基础资源表-列表*/
  cardBaseResourcesSelectList (data, errorback) {
    return request._get('/shop/cardApply/cardBaseResources/selectList', data, errorback);
  },
}

export default OrderApi;



// WEBPACK FOOTER //
// ./src/api/cardresources.js